import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useLenis } from '../lenis/LenisProvider.jsx'
import { usePageTransition } from '../transitions/PageTransition.jsx'
import TransitionLink from '../transitions/TransitionLink'
import './header.css'

export default function Header() {
  const location = useLocation()
  const lenis = useLenis()
  const transition = usePageTransition()
  const isHome = location.pathname === '/'

  const handleSectionClick = (e, id) => {
    if (isHome) {
      e.preventDefault()
      lenis?.scrollTo(`#${id}`)
    }
    // Si on n'est pas sur la home, on laisse le lien natif nous y ramener
    // (Home.tsx gère ensuite le scroll vers l'ancre via location.hash).
  }

  const sectionHref = (id) => (isHome ? `#${id}` : `/#${id}`)

  return (
    <nav className="nav">
      <Link
        to="/"
        className="nav-brand"
        onClick={(e) => {
          e.preventDefault()
          if (isHome) lenis?.scrollTo(0)
          else transition?.navigateWithTransition('/')
        }}
      >
        <span className="nav-logo">RD</span>
        <span className="nav-name">Romain Danizel</span>
      </Link>

      <div className="nav-links">
        <a href={sectionHref('about')} className="nav-link" onClick={(e) => handleSectionClick(e, 'about')}>About</a>
        <a href={sectionHref('projects')} className="nav-link" onClick={(e) => handleSectionClick(e, 'projects')}>Projets</a>
        <TransitionLink to="/cv" className="nav-link">CV</TransitionLink>
        <a
          href="mailto:romain.danizel.pro@gmail.com"
          className="nav-link nav-cta"
        >
          Me contacter
        </a>
      </div>
    </nav>
  )
}
